import './vimeo-player.scss';
import Player from '@vimeo/player';

class VimeoPlayer {
    constructor (element, options) {
        this.$vimeoPlayer = element;
        const settings = {
            id: this.$vimeoPlayer.getAttribute('data-vimeo-player-id')
        };

        this.settings = Object.assign({}, settings, options);
        this.initialized = false;
    }

    initialize () {
        let Cookiebot = null;
        window.addEventListener('CookiebotOnConsentReady', () => {
            Cookiebot = window.Cookiebot;

            if (Cookiebot.consent.marketing === true) {
                this.initPlayer();
            }
        });

        window.addEventListener('CookiebotOnAccept', () => {
            Cookiebot = window.Cookiebot;
            if (Cookiebot.consent.marketing) {
                this.initPlayer();
            }
        });
    }

    initPlayer () {
        let $player = null;
        if (this.initialized === false) {
            $player = new Player(this.$vimeoPlayer, {
                id: this.settings.id,
                controls: true
            });

            this.initialized = true;
            setTimeout(() => {
                this.setContainerSize($player);
            }, 500);

            this.play($player);
        }
    }

    play ($player) {
        $player.on('play', function () {
            console.log('played the video!');
        });
    }

    setContainerSize ($player) {
        this.$vimeoPlayer.style.aspectRatio = $player.element.width / $player.element.height;
    }
}

export { VimeoPlayer };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$vimeoPlayer = $context.querySelectorAll('[data-vimeo-player="root"]');
        for (let i = 0; i < $$vimeoPlayer.length; i++) {
            const $vimeoPlayer = new VimeoPlayer($$vimeoPlayer[i]);
            $vimeoPlayer.initialize();
        }
    }
});
